import { Button, Text, Spacer } from "@hackthenorth/north";
import React from "react";
import "twin.macro";

import Modal from "src/shared/components/Modal";

interface PerkConfirmationModalProps {
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
}

export const PerkConfirmationModal: React.FC<PerkConfirmationModalProps> = ({
  onConfirm,
  onClose,
  isOpen,
  title = "Confirmation",
  message = "Are you sure you want to submit this perk?",
  confirmLabel = "Submit",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      actions={
        <>
          <div className="left"></div>
          <div className="right" tw="flex">
            <Button mods="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Spacer width="16px" />
            <Button
              mods="primary"
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              {confirmLabel}
            </Button>
          </div>
        </>
      }
    >
      <Text>{message}</Text>
    </Modal>
  );
};
